<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <h2>Attendance</h2>
            </CCardHeader>
            <CCardBody>
                <div class="col-xs-6 text-bold pb-2">
                    <CRow>
                        <CCol sm="2">
                            <label class="form-label font-weight-bold">Period</label>
                            <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                        </CCol>
                        <CCol >
                            <date-picker
                            v-model="Period"
                            @input="periodSelected()"
                            format="MMM YYYY"
                            type="month"
                            placeholder="Pilih Period"
                            value-type="M-YYYY"
                            style="width:20%"
                            v-bind:clearable="false"
                            ></date-picker>
                        </CCol>
                    </CRow>
                   
                </div>
                <div class="col-xs-6 text-light pb-2">
                    <button id="add" class="btn btn-success"                   
                    @click="addClick()">
                        <i class="fa fa-plus"></i> Add
                    </button>
                </div>
                <attendance-grid 
                    :key="gridReload" 
                    :deleteClick="deleteClick" 
                    :editClick="editClick"
                    :period="Period"
                />
                <attendance-form ref="attendanceForm" :reload="reload"/>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import attendanceService from '../Attendance/Script/AttendanceService.js';
import attendanceGrid from '../Attendance/Grid/AttendanceGrid.vue';
import attendanceForm from '../Attendance/Component/AttendanceForm.vue';
import datePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { ref } from 'vue';
import { response } from '../../../infrastructure/constant/response';
import { sweet_alert } from '../../../infrastructure/constant/variable';

export default {
    name: 'Attendance',
    components: {
        'attendance-grid': attendanceGrid,
        'attendance-form': attendanceForm,
        'date-picker' : datePicker,
    },
   
    data(){
        var period = this.periodSelected();
        return{
            gridReload: 0,
            Period: period,
        }
    },
    mounted () {
        var permission = this.$globalfunc.permissionModule('Attendance');
        document.getElementById("add").disabled = permission.cperms ? false : true;
    },

    methods: {
        addClick(){
            this.$refs.attendanceForm.addClick();
        },
        editClick(month, year, employeeId, view){
            this.$refs.attendanceForm.editClick(month, year, employeeId, view);
        },
        deleteClick(id){
            this.$swal(sweet_alert.delete).then((result) => {
                var variables = {
                    id : id
                }
                if (result.isConfirmed == true) {
                    attendanceService.deleteQuery(variables).then(res =>{
                        this.reload();
                        this.$swal("Info", response.successDelete, "success");
                    })
                    .catch(e => {
                        var errorMessage = this.$globalfunc.errorExtractor(e)
                        this.$swal("Error", errorMessage, "error");
                    })
                }
            })
        },
        reload(){
            this.gridReload++;
        },
        periodSelected() {
            if (this.Period == null ){
                var d = new Date();
                let year = d.getFullYear();
                let month = d.getMonth()+1;
                this.Period = month.toString()+'-'+year.toString();
            }
            this.reload();
            return this.Period; 
        },
        
    }
}
</script>

<style scoped>
</style>